export default [
    /*** 管理员登录日志  ***/
    {
        path: '/loginrecord',
        component: () => import('../pages/setting/loginrecord/index.vue'),
        meta: { title: '登录日志' }
    },
    /*** 问题反馈  ***/
    {
        path: '/feedback',
        component: () => import('../pages/setting/feedback/index.vue'),
        meta: { title: '问题反馈' }
    },
     /*** 订单进度  ***/
    {
        path: '/ordermission',
        component: () => import('../pages/setting/ordermission/index.vue'),
        meta: { title: '任务进度' }
  },
  // 运费模板
     {
        path: '/freight',
        component: () => import('../pages/setting/freight/index.vue'),
        meta: { title: '运费模板' }
  },
  //运费模板创建
     {
    path: '/freight/create',
      component: () => import('../pages/setting/freight/create.vue'),
    meta: {title: '模板创建'}
  },
    //运费模板编辑
      {
    path: '/freight/edit',
      component: () => import('../pages/setting/freight/edit.vue'),
    meta: {title: '模板比编辑'}
  },
    
]
